export const letterF = {
  nouns: [
    {"driver": ["Fahrer", "Fahrer", "der", "die", "m"]},
    {"ticket": ["Fahrkarte", "Fahrkarten", "die", "die", "f"]},
    {"bicycle": ["Fahrrad", "Fahrräder", "das", "die", "n"]},
    {"family": ["Familie", "Familien", "die", "die", "f"]},
    {"family name": ["Familienname", "Familiennamen", "der", "die", "m"]},
    {"family name": ["Nachname", "Nachnamen", "der", "die", "m"]},
    {"marital status": ["Familienstand", "Familienstände", "der", "die", "m"]},
    {"color": ["Farbe", "Farben", "die", "die", "f"]},
    {"fax": ["Fax", "Faxe", "das", "die", "n"]},
    {"fire": ["Feuer", "Feuer", "das", "die", "n"]},
    {"fever": ["Fieber", "Fieber", "das", "die", "n"]},
    {"film": ["Film", "Filme", "der", "die", "m"]},
    {"company": ["Firma", "Firmen", "die", "die", "f"]},
    {"fish": ["Fisch", "Fische", "der", "die", "m"]},
    {"bottle": ["Flasche", "Flaschen", "die", "die", "f"]},
    {"meat": ["Fleisch", "Fleisch", "das", "die", "n"]},
    {"flight": ["Abflug", "Abflüge", "der", "die", "m"]},
    {"airport": ["Flughafen", "Flughäfen", "der", "die", "m"]},
    {"airplane": ["Flugzeug", "Flugzeuge", "das", "die", "n"]},
    {"form": ["Formular", "Formulare", "das", "die", "n"]},
    {"photo": ["Foto", "Fotos", "das", "die", "n"]},
    {"question": ["Frage", "Fragen", "die", "die", "f"]},
    {"woman": ["Frau", "Frauen", "die", "die", "f"]},
    {"free time": ["Freizeit", "Freizeiten", "die", "die", "f"]},
    {"friend": ["Freund", "Freunde", "der", "die", "m"]},
    {"breakfast": ["Frühstück", "Frühstücke", "das", "die", "n"]},
    {"tour": ["Führung", "Führungen", "die", "die", "f"]},
    {"foot": ["Fuß", "Füße", "der", "die", "m"]},
    {"soccer": ["Fußball", "Fußbälle", "der", "die", "m"]}
  ],
  verbs: [
    {"to drive": ["fahren", "fahre", "fährst", "fährt", "fährt", "fährt", "fahren", "fahrt", "fahren", "fahren"]},
    {"to celebrate": ["feiern", "feiere", "feierst", "feiert", "feiert", "feiert", "feiern", "feiert", "feiern", "feiern"]},
    {"to miss": ["fehlen", "fehle", "fehlst", "fehlt", "fehlt", "fehlt", "fehlen", "fehlt", "fehlen", "fehlen"]},
    {"to watch TV": ["fernsehen", "sehe fern", "siehst fern", "sieht fern", "sieht fern", "sieht fern", "sehen fern", "seht fern", "sehen fern", "sehen"]},
    {"to find": ["finden", "finde", "findest", "findet", "findet", "findet", "finden", "findet", "finden", "finden"]},
    {"to fly": ["fliegen", "fliege", "fliegst", "fliegt", "fliegt", "fliegt", "fliegen", "fliegt", "fliegen", "fliegen"]},
    {"to take off": ["abfliegen", "fliege ab", "fliegst ab", "fliegt ab", "fliegt ab", "fliegt ab", "fliegen ab", "fliegt ab", "fliegen ab"]},
    {"to ask": ["fragen", "frage", "fragst", "fragt", "fragt", "fragt", "fragen", "fragt", "fragen", "fragen"]},
    {"to be happy": ["freuen", "freue mich", "freust dich", "freut sich", "freut sich", "freut sich", "freuen uns", "freut euch", "freuen sich", "freuen sich"]},
    {"to have breakfast": ["frühstücken", "frühstücke", "frühstückst", "frühstückt", "frühstückt", "frühstückt", "frühstücken", "frühstückt", "frühstücken", "frühstücken"]}
  ],
  examples: {
    nominative: [
      {
        german: '___ Fahrer kommt.',
        english: 'The driver comes.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Familie ist groß.',
        english: 'The family is big.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Feuer ist heiß.',
        english: 'The fire is hot.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Frau arbeitet.',
        english: 'The woman works.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Freund spielt.',
        english: 'The friend plays.',
        answer: 'Der',
        case: 'nominative'
      }
    ],
    accusative: [
      {
        german: 'Ich sehe ___ Fahrer.',
        english: 'I see the driver.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Er kauft ___ Fahrkarte.',
        english: 'He buys the ticket.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Sie braucht ___ Formular.',
        english: 'She needs the form.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Wir haben ___ Frage.',
        english: 'We have a question.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du liest ___ Buch.',
        english: 'You read the book.',
        answer: 'das',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich helfe ___ Fahrer.',
        english: 'I help the driver.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie gibt ___ Freund ___ Foto.',
        english: 'She gives the friend the photo.',
        answer: 'dem das',
        case: 'dative'
      },
      {
        german: 'Er spricht mit ___ Frau.',
        english: 'He speaks with the woman.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Wir danken ___ Familie.',
        english: 'We thank the family.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du gehst zu ___ Freund.',
        english: 'You go to the friend.',
        answer: 'dem',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The driver comes.',
        german: 'Der Fahrer kommt.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The family is big.',
        german: 'Die Familie ist groß.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'I see the driver.',
        german: 'Ich sehe den Fahrer.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'She gives the friend the photo.',
        german: ['Sie gibt dem Freund das Foto.', 'Sie gibt dem Freund das Bild.'],
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'The woman works.',
        german: ['Die Frau arbeitet.', 'Die Dame arbeitet.'],
        type: 'translation',
        caseType: 'nominative'
      }
    ],
    conjugations: [
      {
        question: 'How do you conjugate "to drive" for "I"?',
        answer: 'fahre',
        verb: 'fahren',
        verbEnglish: 'to drive',
        subject: 'ich',
        conjugation: 'fahre'
      },
      {
        question: 'How do you conjugate "to celebrate" for "you" (informal)?',
        answer: 'feierst',
        verb: 'feiern',
        verbEnglish: 'to celebrate',
        subject: 'du',
        conjugation: 'feierst'
      },
      {
        question: 'How do you conjugate "to find" for "he"?',
        answer: 'findet',
        verb: 'finden',
        verbEnglish: 'to find',
        subject: 'er',
        conjugation: 'findet'
      },
      {
        question: 'How do you conjugate "to ask" for "we"?',
        answer: 'fragen',
        verb: 'fragen',
        verbEnglish: 'to ask',
        subject: 'wir',
        conjugation: 'fragen'
      },
      {
        question: 'How do you conjugate "to fly" for "they" (formal)?',
        answer: 'fliegen',
        verb: 'fliegen',
        verbEnglish: 'to fly',
        subject: 'Sie',
        conjugation: 'fliegen'
      }
    ]
  }
}
